export default __webpack_public_path__ + "e174fb5245bab30eaed4471a32e513cc.svg";